import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const HeaderNotificationDropdownSkeleton = () => {
  return (
    <div className="tw-p-4 tw-space-y-4">
      {[...Array(3)].map((_, index) => (
        <div key={index} className="tw-flex tw-items-center tw-space-x-4">
          <Skeleton
            circle
            width={40}
            height={40}
            containerClassName="tw-flex-shrink-0"
          />
          <div className="tw-flex-grow tw-space-y-2">
            <Skeleton height={16} width="80%" />
            <Skeleton height={12} width="60%" />
          </div>
          <Skeleton width={60} height={20} containerClassName="tw-ml-auto" />
        </div>
      ))}
    </div>
  );
};

export default HeaderNotificationDropdownSkeleton;
